<template>
  <div>
    <div class="content-box">
      <div class="os-tabs-w" v-if="current.id">
        <div class="os-tabs-controls os-tabs-complex text-right">
          <ul class="nav nav-tabs col-12">
            <li class="nav-item col-6">
              <span aria-expanded="true" class="nav-link active">
                <span>Cargo:&nbsp;</span>
                <span class="tab-value">Q{{ current.valor_total }}</span>
              </span>
            </li>
            <li class="nav-item col-6">
              <span aria-expanded="true" class="nav-link active">
                <span>Devuelto:&nbsp;</span>
                <span class="tab-value">Q{{ current.valor_total_devuelto }}</span>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <div>
                <div>
                  <router-link class="back-to-index" :to="{ name: 'wms-devolucion-mayoreo' }">
                    <i class="os-icon os-icon-arrow-left5" style="color: purple;"></i>
                    <span class="text-dark" style="color: purple;">&nbsp;Atrás</span>
                  </router-link>
                </div>
                <div style="text-align:right ;">
                  <span class="font-weight-bold"> Fecha:</span>
                  <span style="color: green"> {{ current.fecha }}</span>
                </div>
                <div style="text-align: left;">
                  <span class="badge" :class="{
                    'badge-success': current.estado == 'A',
                    'badge-warning': current.estado == 'B',
                    'badge-danger': current.estado == '9',
                  }">
                    <i class="os-icon os-icon-ui-09"></i>
                    <span v-if="current.estado_str">{{
                      current.estado_str
                    }}</span>
                    <span v-if="!current.estado_str">En Proceso</span>
                  </span>
                </div>
              </div>
              <hr />
              <h6 v-if="current.id" class="form-header" style="text-align: center;">
                Devolución a Cliente Mayorista
                <br>
                <b>#{{ current.numero }}</b>
                <br>
              </h6>
              <small v-if="current.errors && current.errors.detail" class="form-text text-danger">{{ current.errors.detail
              }}</small>
              <br>
              <div>
                <span class="font-weight-bold">Nit cliente:</span>
                <span style="color: green">
                  {{ current.cargo.cliente_nit }}</span>
                <br />
                <span class="font-weight-bold"> Nombre cliente:</span>
                <span style="color: green">
                  {{ current.cargo.cliente_nombre }}</span>
                <br />
              </div>
              <br>
              <div>
                <span class="font-weight-bold">Tienda:</span>
                <span style="color: green"> {{ current.tienda }}</span>
                <br />
                <span class="font-weight-bold"> Cajero: </span><span style="color: green"> {{ current.usuario }}</span>
                <br />
                <span class="font-weight-bold"> Caja: </span><span style="color: green"> {{ current.caja }}</span>
              </div>
              <!-- Boton de acciones flotantes start  -->
              <div class="fab">
                <div @click="abrirModalOpciones()" class="btn-round">
                  <i id="addIcon"><i class="fas fa-bars"></i></i>
                </div>
              </div>
              <!-- Boton de acciones flotantes END  -->
              <!-- aqui se empieza el modal de opciones -->
              <div aria-hidden="true" class="modal fade" id="modalOpciones" role="dialog" tabindex="-1">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div class="modal-body">
                      <button class="activity-box btn-sm btn-block" style="margin-top: 0.14rem; padding: 0.4rem"
                        @click="abrir" :disabled="!(current.estado == 'B')">
                        <div class="activity-avatar">
                          <i class="fa fa-unlock fa-1x"></i>
                        </div>
                        <div class="activity-info">
                          <span class="font-weight-bold">Abrir operación</span>
                        </div>
                      </button>
                      <button class="activity-box btn-sm btn-block" style="margin-top: 0.14rem; padding: 0.4rem"
                        @click="cerrar" :disabled="!(current.estado == 'A')">
                        <div class="activity-avatar">
                          <i class="fa fa-lock fa-1x"></i>
                        </div>
                        <div class="activity-info">
                          <span class="font-weight-bold">Cerrar operación</span>
                        </div>
                      </button>
                      <button class="activity-box btn-sm btn-block" style="margin-top: 0.14rem; padding: 0.4rem"
                        @click="anular" :disabled="!(current.estado != '9')">
                        <div class="activity-avatar">
                          <i class="fa fa-times fa-1x"></i>
                        </div>
                        <div class="activity-info">
                          <span class="font-weight-bold">Anular operación</span>
                        </div>
                      </button>
                      <button class="activity-box btn-sm btn-block" style="margin-top: 0.14rem; padding: 0.4rem"
                        @click="generar_nc" :disabled="!(current.estado != 'A')">
                        <div class="activity-avatar">
                          <i class="fas fa-comments-dollar fa-1x"></i>
                        </div>
                        <div class="activity-info">
                          <span class="font-weight-bold">Generar nota crédito
                          </span>
                        </div>
                      </button>
                      <button class="activity-box btn-sm btn-block" style="margin-top: 0.14rem; padding: 0.4rem"
                        :disabled="current.estado == 'A'" @click="imprimir()">
                        <div class="activity-avatar">
                          <i class="fa fa-print fa-1x"></i>
                        </div>
                        <div class="activity-info">
                          <span class="font-weight-bold">Imprimir</span>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <br>
              <br>
              <br>
              <hr />
              <!-- aqui termina el modal de opciones -->
              <h6 v-if="current.devolucioncliented_set != ''">
                Detalle de la Devolución
              </h6>

              <div class="table-responsive" v-if="current.devolucioncliented_set != ''">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th></th>
                      <th style="width: 120px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="detalle in current.devolucioncliented_set" v-bind:key="detalle.id"
                      style="background-color: #e8f8ff">
                      <td>
                        <div class="value">
                          <small class="font-weight-bold">{{
                            detalle.producto.sku
                          }}</small>
                        </div>
                        <small>
                          <div class="value">
                            {{ detalle.producto.nombre }}
                          </div>
                        </small>
                        Precio linea:
                        <span class="sub-value font-weight-bold" style="color: blue">
                          Q{{ detalle.precio_unitario }}
                        </span>
                      </td>
                      <td>
                        Pendiente:
                        <span class="sub-value font-weight-bold text-success">
                          {{ detalle.cantidad_pendiente_devolucion }}
                        </span>
                        <br />
                        Devolver:
                        <span class="sub-value font-weight-bold" style="color: blue">
                          {{ detalle.cantidad }}
                        </span>
                        <br />
                        Total:
                        <span class="sub-value font-weight-bold text-success">
                          Q{{ detalle.valor_total }}
                        </span>
                      </td>
                      <td>
                        <button v-if="current.estado == 'A'" @click="deleteDetalle(detalle)"
                          class="btn btn-danger btn-sm">
                          <i class="far fa-minus-square"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="floated-chat-btn" data-toggle="modal" @click="showModalAdddevolucion(detalle)"
                v-if="current.estado == 'A'">
                <i class="fas fa-plus"></i>&nbsp;Agregar Devolución
              </div>
              &nbsp;&nbsp;
            </div>
          </div>
        </div>
      </div>
    </div>
    <div aria-hidden="true" class="modal fade" id="modalAdddevolucionDetalle" role="dialog" tabindex="-1">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Agregar Devolución</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <span class="font-weight-bold" style="color: blue; font-size: 15px" v-if="producto">
                <div class="text-center">
                  <span class="text-dark">{{ producto.sku }} </span> -
                  {{ producto.nombre }}
                  <i class="fas fa-check text-success"></i>
                </div>
                <hr />
                <div class="row">
                  <div class="col-8">
                    <span style="font-size: 13px"
                      class="text-secondary">Facturada:</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                        currentCargo.cantidad_facturada
                      }}
                    <br />
                    <span style="font-size: 13px" class="text-secondary">Total devuelta:
                      <span
                        class="text-danger">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                          currentCargo.total_devuelto
                        }}</span></span>
                    <br />
                    <span style="font-size: 13px" class="text-secondary">Pendiente por devolver:
                      <span class="text-success">&nbsp;{{ currentCargo.cantidad_pendiente }}</span></span>
                  </div>
                  <div class="col-4">
                    <button v-if="producto" @click="clearProducto()" class="btn btn-md btn-block btn-outline-dark">
                      <i class="fas fa-sync"></i>
                      <br />
                      reset
                    </button>
                  </div>
                </div>
              </span>
              <small v-if="errors" class="form-text text-danger">{{
                errors.producto
              }}</small>
              <div class="col-12">
                <div class="form-group">
                  <label v-if="!producto" for>Producto</label>
                  <input v-if="!producto" @change="refreshProducto(barra)" class="form-control" placeholder="Producto"
                    type="text" v-model="barra" ref="productox" />
                </div>
                <small v-if="errors && errors.sku" class="form-text text-danger">{{ errors.sku }}</small>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label>Barra posición</label>
                  <input type="text" v-model="currentDetalle.posicion" class="form-control"
                    placeholder="Escanne la barra de la estación" />
                  <small v-if="currentDetalle.errors && currentDetalle.errors.posicion
                    " class="form-text text-danger">{{ currentDetalle.errors.posicion }}</small>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label>Cantidad para devolver</label>
                  <input v-model="currentDetalle.cantidad" class="form-control" type="text"
                    placeholder="Cantidad a Devolver" ref="cantidadx" />
                  <small v-if="currentDetalle.errors && currentDetalle.errors.cantidad
                    " class="form-text text-danger">{{ currentDetalle.errors.cantidad }}</small>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-lg btn-success btn-block" @click="agregaDetalle()" type="button">
              Agregar <i class="fas fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CommonService from "@/services/commons/CommonService";
import PosicionesService from "@/services/inventario/PosicionesService";
import DevolucionesService from "@/services/inventario/DevolucionesService";
import Notifications from "@/notifications/notifications";
import CargosService from "@/services/cxc/CargosService";
import CajaService from "@/services/cxc/CajaService";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {},
  data() {
    return {
      posiciones: "",
      producto: "",
      barra: null,
      detalle: "",
      current: {
        detalle: "",
        id: null,
        devolucioncliented_set: null,
        caja: "",
        cargo_id: "",
        cargo_d: "",
        cargo: "",
        observacion: "",
        cargo_numero: "",
        estado_str: null,
        tienda: "",
        fecha: "01-01-2019",
        estado: "A",
        estado_str: "",
        total: "",
        cliente_nombre: "",
        cliente_nit: "",
        numero: "",
        errors: [],
        cxcabonod_set: [],
        cxcabonocontab_set: [],
        cxcaplicacionabonocargo_set: [],
      },
      errors: [],
      productos: [],
      currentDetalle: {
        cantidad: "",
        posicion: "",
        producto: "",
        codigo_lote: 0,
        productolote_set: [],
        errors: [],
      },
      currentCargo: {
        cantidad_pendiente: 0,
      },
    };
  },
  computed: {
    ...mapGetters({
      caja: "cargos/caja",
    }),
  },
  mounted() {
    let self = this;
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
      self.formatoFecha();
    });
    this.$store.dispatch("cargos/caja", {
      activa: true,
      quitar_paginacion: true,
    });
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
    self.refreshCaja();
    if (!this.$route.params.id) {
      self.cargoCurrent();
    }
  },
  methods: {
    abrirModalOpciones() {
      $("#modalOpciones").modal("show");
    },
    clearProducto() {
      if (this.producto) {
        this.producto = "";
        this.barra = "";
      }
    },
    buscarProductoFactura(sku) {
      let self = this;
      DynamicService.postAction(
        "inv",
        "devolucion_cliente",
        self.current.id,
        "buscar_detalle_factura",
        { sku: sku }
      )
        .then((response) => {
          self.currentCargo = response.data;
        })
        .catch((error) => {
          self.error = error.response.data;
          if (error.response && error.response.data.detail) {
            Notifications.alert.error(
              "Buscar producto",
              error.response.data.detail
            );
          }
        });
    },
    refreshProducto(barra) {
      let self = this;
      if (!barra) {
        self.errors.producto = "Este campo no puede ser nulo";
        return;
      }
      DynamicService.fetch("cat", "producto-barra", {
        barra: barra,
        activo: true,
      })
        .then((response) => {
          self.producto = response.data.results[0].producto_obj;
          self.buscarProductoFactura(self.producto.sku);
          self.currentDetalle.barra = self.producto.sku;
          self.errors.producto = "";
          setTimeout(function () {
            self.$refs.cantidadx.focus();
          }, 100);
        })
        .catch((err) => {
          self.producto = null;
          self.errors.producto = "No existe producto";
        });
    },
    formatoFecha() {
      let self = this;
      self.current.fecha = self.current.fecha.replace(/\//g, "-");
    },
    onSearchPosicion(search, loading) {
      loading(true);
      this.searchPosicion(loading, search, this);
    },
    searchPosicion: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);

        return;
      }
      let that = this;

      PosicionesService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.codigo_barra = res.data;
        loading(false);
      });
    }, 350),

    showModalAdddevolucion(detalle) {
      let self = this;
      $("#modalAdddevolucionDetalle").modal();
    },

    generar_nc() {
      let self = this;
      $("#modalOpciones").modal("hide");
      let current = Object.assign({}, self.current);
      DevolucionesService.generar_nc(self.current.id, current)
        .then((response) => {
          Notifications.alert.success(
            "Devoluciones",
            "Se ha Generado la Nota de Credito."
          );
          self.refreshCurrent();
          self.imprimir();
        })
        .catch((error) => {
          Notifications.alert.error("Devolución", error.response.data.detail);
        });
    },
    agregaDetalle() {
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      det.producto = self.producto.sku;
      console.log(det.producto);
      det.cargo_e = self.currentCargo.cargo_e;
      DynamicService.postAction(
        "inv",
        "devolucion_cliente",
        self.current.id,
        "agregar_detalle_mayoreo",
        det
      )
        .then((response) => {
          Notifications.alert.success("Devolución", "Se ha agregado producto.");
          self.refreshCurrent();
          self.refreshDetalleDefault();
          $("#modalAdddevolucionDetalle").modal("hide");
          self.clearProducto();
        })
        .catch((error) => {
          self.refreshDetalleDefaultError();
          self.currentDetalle.errors = error.response.data;
          if (error.response && error.response.data.detail) {
            Notifications.alert.error("¡Atención!", error.response.data.detail);
          }
          self.clearProducto();
        });
    },
    deleteDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Detalle Devolución",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          DevolucionesService.eliminar_detalle(self.current.id, {
            id: detalle.id,
          })
            .then((response) => {
              Notifications.alert.success(
                "Detalle de devolución",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;
            });
        }
      );
    },
    refreshCurrent() {
      let self = this;
      DevolucionesService.getById(this.$route.params.id).then((response) => {
        self.current.devolucioncliented_set =
          response.data.devolucioncliented_set;
        self.current.id = response.data.id;
        self.current.usuario = response.data.usuario.name;
        self.current.observacion = response.data.observacion;
        self.current.caja = response.data.caja.caja;
        self.current.tienda = response.data.caja.tienda;
        self.current.cargo_id =
          response.data.devolucionclienteecargoe_set[0].cargo_e.id;
        self.current.cargo_numero =
          response.data.devolucionclienteecargoe_set[0].cargo_e.numero;
        self.current.numero = response.data.numero;
        self.current.estado = response.data.estado;
        self.current.estado_str = response.data.estado_str;
        self.current.tienda = response.data.tienda.codigo;
        self.current.cargo =
          response.data.devolucionclienteecargoe_set[0].cargo_e;
        self.current.valor_total_devuelto = response.data.valor_total_devuelto;
        self.current.valor_total =
          response.data.devolucionclienteecargoe_set[0].cargo_e.valor_total;
        self.cargoDetalleCurrent();
      });
    },

    cargoCurrent() {
      let self = this;
      CargosService.getById(this.$route.params.cargo).then((response) => {
        self.current.cargo_id = response.data.id;
        self.current.cargo_numero = response.data.numero;
      });
    },
    cargoDetalleCurrent() {
      let self = this;
      let current = Object.assign({}, self.current);
      CargosService.getById(current.cargo_id).then((response) => {
        self.currentCargo = response.data;
      });
    },

    guardar(e) {
      e.preventDefault();
      let self = this;
      let current = Object.assign({}, self.current);
      CargosService.getById(current.cargo_id).then((response) => {
        self.current.cargo_d = response.data.cxccargod_set;
      });
      DevolucionesService.save(current)
        .then((response) => {
          if (current.id == null) {
            Notifications.alert.success("Devuluciones", "Ir a detalle.", "");
            self.$refs.cerrarModalDetalle.click();
            self.$router.push({
              name: "inventario-devoluciones-editar",
              params: { id: response.data.id },
            });
            self.refreshCurrent();
          }
        })
        .catch((error) => {
          self.current.errors = error.response.data;
          if (error.response.data.devolucion_cliente) {
            Notifications.alert.error(
              "Error",
              error.response.data.devolucion_cliente
            );
          }
        });
    },

    abrir() {
      let self = this;
      $("#modalOpciones").modal("hide");
      Notifications.alert.confirm(
        "Abonos",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          DevolucionesService.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Abonos",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Abrir Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    cerrar() {
      let self = this;
      $("#modalOpciones").modal("hide");
      Notifications.alert.confirm(
        "Abonos",
        "Desea cerrar la transacción?",
        "Si Abrir",
        function () {
          DevolucionesService.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Abonos",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Cerrar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    anular() {
      let self = this;
      $("#modalOpciones").modal("hide");
      Notifications.alert.confirm(
        "Abonos",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          DevolucionesService.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Abonos",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Anular Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    onSearchCliente(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      vm.$store.dispatch("catalogos/clientes", {
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      });
      loading(false);
    }, 350),

    onSearchCargo(search, loading) {
      loading(true);
      this.searchCargo(loading, search, this);
    },
    searchCargo: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      CargosService.fetch({
        page: 1,
        quitar_paginacion: true,

        "filter[search]": search,
      }).then((res) => {
        vm.cargo = res.data;
        loading(false);
      });
    }, 350),

    refreshCaja() {
      let self = this;
      self.$store.dispatch("cargos/caja", {
        activa: true,
        quitar_paginacion: true,
      });
    },
    refreshDetalleDefaultError() {
      let self = this;
      self.currentDetalle = {
        cantidad: "",
        posicion: "",
        producto: {
          nombre: "",
        },
      };
    },
    refreshDetalleDefault() {
      let self = this;
      self.currentDetalle = {
        cantidad: "",
        posicion: "",
        errors: [],
        producto: {
          nombre: "",
        },
      };
    },
    imprimir() {
      let self = this;
      self.id = self.current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=Nota_Credito_Carta.jrxml&Id=${self.current.id}`
      );
    },
  },
};
</script>
